import { Button, Select, notification } from "antd";
import { useState } from "react";
import { siteAPI } from "../../api";

interface IProps {
  selectedSiteIds: string[];
  onSuccess: () => void;
}

export const UpdateDomainAutoRenew = ({
  selectedSiteIds,
  onSuccess,
}: IProps) => {
  const [autoRenew, setAutoRenew] = useState<boolean | null>(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = async () => {
    if (selectedSiteIds.length === 0) {
      notification.warning({
        message: "No sites selected",
        description: "Please select at least one site",
      });
      return;
    }

    if (autoRenew === null) {
      notification.warning({
        message: "No value selected",
        description: "Please select auto renew value (true/false)",
      });
      return;
    }

    setIsUpdating(true);
    try {
      const response = await siteAPI.updateDomainAutoRenew(
        selectedSiteIds,
        autoRenew
      );

      if (response.status === "success") {
        notification.success({
          message: "Success",
          description: response.message || "Domain auto-renew updated successfully",
        });
        setAutoRenew(null);
        onSuccess();
      } else {
        notification.error({
          message: "Error",
          description: response.message || "Failed to update domain auto-renew",
        });
      }
    } catch (error: any) {
      notification.error({
        message: "Error",
        description:
          error?.response?.data?.message ||
          "An error occurred while updating domain auto-renew",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div style={{ display: "flex", gap: 10, marginTop: 10, alignItems: "center" }}>
      <span style={{ fontWeight: 500 }}>Domain Auto Renew:</span>
      <Select
        style={{ width: 150 }}
        placeholder="Select value"
        value={autoRenew}
        onChange={(value) => setAutoRenew(value)}
        options={[
          { value: true, label: "True" },
          { value: false, label: "False" },
        ]}
        allowClear
        onClear={() => setAutoRenew(null)}
      />
      <Button
        type="primary"
        loading={isUpdating}
        onClick={handleUpdate}
        disabled={selectedSiteIds.length === 0 || autoRenew === null}
      >
        Update {selectedSiteIds.length > 0 && `(${selectedSiteIds.length})`}
      </Button>
    </div>
  );
};
